const resource = {
  "agentWithdrawals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent withdrawals"])},
  "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History"])},
  "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
  "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
  "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payouts"])},
  "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])}
}
export default resource